import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd-mobile";
import { useTranslation } from "react-i18next";
import filterTypeEnum from "../../../../enumerations/filterTypeEnum";
import FilterTypeDateTimeRange from "../../../FilterTypeDateTimeRange";
import FilterTypeDropdownSelect from "../../../FilterTypeDropdownSelect";
import FilterTypeSelect from "../../../FilterTypeSelect";
import styles from "./style.module.scss";
import "./style.scss";
const FilterDrawerMultiDropdown = ({
  filters = [],
  localFilterValue = {},
  setLocalFilterValue = () => { },
  onReset = () => { },
  onSubmitSearch = () => { },
}) => {
  const { t } = useTranslation();

  const onHandleSumbit = () => {
    onSubmitSearch();
  };

  const onHandleReset = () => {
    onReset();
  };

  const setSelectValue = (value, filter) => {
    setLocalFilterValue((prevState) => {
      return {
        ...prevState,
        [filter.data_index]: value,
      };
    });
  };

  const setDateTimeValue = (value, filter, type) => {
    switch (type) {
      case "start":
        setLocalFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index[0]]: value,
          };
        });
        break;
      case "end":
        setLocalFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index[1]]: value,
          };
        });
        break;
      default:
        break;
    }
  };

  const renderFilter = (filter) => {
    switch (filter.type) {
      case filterTypeEnum.SELECT:
        return (
          <FilterTypeSelect
            required={filter.required}
            columns={filter.columns}
            options={filter.value_enum.map((val) => {
              return {
                ...val,
                label: val.is_translation ? t(val.label) : val.label,
              };
            })}
            value={
              localFilterValue[filter.data_index] !== null
                ? [localFilterValue[filter.data_index]]
                : []
            }
            setValue={(value) => setSelectValue(value, filter)}
          />
        );
      case filterTypeEnum.DATE_TIME_RANGE:
        return (
          <FilterTypeDateTimeRange
            startDate={localFilterValue[filter.data_index[0]]}
            endDate={localFilterValue[filter.data_index[1]]}
            setStartDateValue={(value) =>
              setDateTimeValue(value, filter, "start")
            }
            setEndDateValue={(date) => setDateTimeValue(date, filter, "end")}
            precision={filter.precision}
            maxMonthInterval={filter.maxMonthInterval}
          />
        );

      case filterTypeEnum.DROPDOWN_SELECT:
        return (
          <FilterTypeDropdownSelect
            required={filter.required}
            columns={filter.columns}
            options={filter.value_enum.map((val) => {
              return {
                ...val,
                label: val.is_translation ? t(val.label) : val.label,
              };
            })}
            value={
              localFilterValue[filter.data_index] !== null
                ? [localFilterValue[filter.data_index]]
                : []
            }
            setValue={(value) => setSelectValue(value, filter)}
          />
        );

      default:
        return (
          <div>
            invalid filter type, filter must be type of Input, DateTimeRange, or
            Select
          </div>
        );
    }
  };
  return (
    <div className={`${styles.container}`}>
      <div className={styles.scroll}>{renderFilter(filters)}</div>
      <div className={styles.buttonContainer}>
        <Button className={styles.reset} onClick={onHandleReset}>
          {t("mobile.filter.clearButton")}
        </Button>
        <Button className={styles.submit} onClick={onHandleSumbit}>
          {t("mobile.filter.submitButton")}
          <RightOutlined />
        </Button>
      </div>
    </div>
  );
};
export default FilterDrawerMultiDropdown;
